import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["assetId", "showSuccessAlert"],
  _excluded2 = ["mutateAsync"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import api from 'utils/api';
import track from 'utils/track';
import { setSuccessAlert, setAlert } from 'actions/alerts';
import { assetQueryKeys } from '.';
function useSendMyAssetFeedback(_ref) {
  var assetId = _ref.assetId,
    _ref$showSuccessAlert = _ref.showSuccessAlert,
    showSuccessAlert = _ref$showSuccessAlert === void 0 ? true : _ref$showSuccessAlert,
    options = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  function sendFeedback(_x) {
    return _sendFeedback.apply(this, arguments);
  }
  function _sendFeedback() {
    _sendFeedback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(feedback) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('put', "/api/me/assets/".concat(assetId, "/likes"), null, feedback));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _sendFeedback.apply(this, arguments);
  }
  var _useMutation = useMutation(sendFeedback, _objectSpread(_objectSpread({}, options), {}, {
      onSuccess: function onSuccess(data, variables) {
        if (showSuccessAlert) {
          setSuccessAlert({
            title: t('alert_feedback_success')
          });
        }
        track('asset', variables !== null && variables !== void 0 && variables.rated_like ? 'liked' : 'unliked', assetId);
        return Promise.all([queryClient.invalidateQueries(assetQueryKeys.singleAsset(assetId)), queryClient.invalidateQueries(assetQueryKeys.allAssetAnalytics)]);
      },
      onError: function onError() {
        setAlert({
          title: t('alert_feedback_error')
        });
      }
    })),
    mutateAsync = _useMutation.mutateAsync,
    result = _objectWithoutProperties(_useMutation, _excluded2);
  return _objectSpread(_objectSpread({}, result), {}, {
    sendMyAssetFeedback: mutateAsync
  });
}
export default useSendMyAssetFeedback;